import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/support")({
	component: () => <Outlet />,
	pendingComponent: () => <Outlet />,
});
